const startTips = [
    {
        title: 'Upload images or .mp4 video files to get started',
        description: 'Click the + icon to import your first media.'
    },
    {
        title: 'Load the desired media',
        description: 'Click on the desired thumbnail to load the media in fylm.ai Lite'
    },
    {
        title: 'Select ACES Input Transform',
        description: 'Select the ACES Input Transform that matches your camera. ACES Input Transform allows fylm.ai Lite to correctly colour manage your workflow.'
    },
    {
        title: 'Add a colour grading tool',
        description: 'Adding a colour grading tool allows you to start creating your look. You can add as many tools as you need.'
    },
    {
        title: 'Save your look as a Candidate',
        description: 'Once you are happy with the look you have created, you can save it as a Candidate. Candidates can easily be copied to other assets to share the same look.'
    },
    {
        title: 'Export your work',
        description: 'Once you are happy with the result, you can export your look as a LUT that can be used in a wide variety of software or save a graded image'
    },
]

export default startTips